import React from 'react';
import fruitsfamilyLogo from "./assets/rounded_logo.svg";
import iconStar from "./assets/ic_yellow_star.svg";
import popupClose from "./assets/popup_close.svg";
import PropTypes from "prop-types";
import {useAppInstallOneLinkUrl} from "../../hook/appUrl";
import {useAppInstallModal} from "../../store/useAppInstallModal";

/**
 * 앱 설치 유도 팝업 모바일 버전
 * @param text
 * @returns {Element}
 * @constructor
 */
export default function AppInstallModalMobile({ text }) {
    const { closeModal } = useAppInstallModal();
    const oneLinkUrl = useAppInstallOneLinkUrl();

    const handleOnClick = () => {
        window.location.href = oneLinkUrl;
    }

    return <div className='AppInstallModal-Mobile-content'>
        <button type="button" onClick={closeModal} className="PopupClose" aria-label="닫기">
            <img src={popupClose} alt='' className="PopupCloseImage" />
        </button>
        <img className="Logo" alt="FruitsFamily™ Logo" src={fruitsfamilyLogo}/>
        <div className="Appstore">
            <div className="Text">App Store 평점</div>
            <div className="StoreRating">
                <div>4.9</div>
                <div className="StoreRatingImages">
                    <div>
                        <img src={iconStar} alt="yellow-star" className="StoreRatingStar" />
                        <img src={iconStar} alt="yellow-star" className="StoreRatingStar" />
                        <img src={iconStar} alt="yellow-star" className="StoreRatingStar" />
                        <img src={iconStar} alt="yellow-star" className="StoreRatingStar" />
                        <img src={iconStar} alt="yellow-star" className="StoreRatingStar" />
                    </div>
                </div>
            </div>
        </div>
        <div className='Title'>{text || '앱에서 후루츠를\n제대로 즐겨보세요!'}</div>
        <button className="AppOpenButton" onClick={handleOnClick}>앱 열기</button>
    </div>
}

AppInstallModalMobile.propTypes = {
    text: PropTypes.string
}
